import { Button, Flex, Form, Modal, Typography } from "antd"
import React from "react"

import { type ProjectTypeCardFormData } from "../../../types/project-type.types.ts"
import { TextArea } from "../../../../../components/Input/TextArea.tsx"
import { TextInput } from "../../../../../components/Input/TextInput.tsx"

const { Title } = Typography

interface AddProjectTypeFormProps {
  saving: boolean
  onSubmit: (data: ProjectTypeCardFormData) => void
  onClose: () => void
}

export function AddProjectTypeFormModal({
  saving,
  onSubmit,
  onClose
}: AddProjectTypeFormProps) {
  const [form] = Form.useForm<ProjectTypeCardFormData>()

  return (
    <Modal
      open
      title={
        <Title level={3} style={{ margin: 0, textAlign: "start" }}>
          Add Project Type Template
        </Title>
      }
      centered={true}
      footer={null}
      maskClosable={false}
      onCancel={onClose}
      width={600}
    >
      <div
        className={"overflow-y-auto flex flex-col size-full"}
        style={{ maxHeight: "calc(100vh - 100px)" }}
      >
        <Form
          form={form}
          clearOnDestroy
          onFinish={onSubmit}
          layout="vertical"
          className={"with-default-error"}
          validateTrigger={["onSubmit", "onChange"]}
          disabled={saving}
        >
          <Form.Item<ProjectTypeCardFormData>
            label={"Name"}
            name="name"
            rules={[{ required: true, whitespace: false }]}
          >
            <TextInput placeholder={"Enter name"} />
          </Form.Item>

          <Form.Item<ProjectTypeCardFormData>
            label={"Description"}
            name="description"
            rules={[{ required: false, whitespace: false }]}
          >
            <TextArea placeholder={"Enter description"} />
          </Form.Item>

          <Flex gap={"middle"} justify={"end"} style={{ marginTop: "24px" }}>
            <Button onClick={onClose} disabled={saving}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={saving}>
              Submit
            </Button>
          </Flex>
        </Form>
      </div>
    </Modal>
  )
}
